const $ = window.$;

$(document)
  .on('ajax:before', '.generating_button[data-remote]', function () {
    $(this).addClass('button--disabled');
  })
  .on('ajax:complete', '.generating_button[data-remote]', function () {
    $(this).removeClass('button--disabled');
  });
